import { ReactNode } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { RootReducer } from 'redux/reducers';
import { showContextMenu } from 'redux/mode/actions';

import ContextMenu from '../ContextMenu';

const GlobalContextMenu = ({ children }: { children: ReactNode }) => {
	const dispatch = useDispatch();

	const { contextMenu } = useSelector(
		(r: RootReducer) => ({
			contextMenu: r.mode.contextMenu,
		}),
		shallowEqual
	);

	const closeMenu = () => {
		dispatch(showContextMenu(null));
	};

	const menuItems = contextMenu?.menuItems.map((x) => x.addCallback(closeMenu));

	return <ContextMenu menuItems={menuItems || null}>{children}</ContextMenu>;
};

export default GlobalContextMenu;
